import { typo } from '@cycle-app/ui';
import styled from 'styled-components';

export const DocTypesContainer = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  padding: 0 8px;
  height: 28px;
  border-radius: 6px;
  ${typo.caption500}
  color: ${p => p.theme.colors.text.primary};
  :hover {
    background: ${p => p.theme.colors.background.tertiary};
  }
`;

export const DocType = styled.div`
  display: inline-flex;
  gap: 4px;
  align-items: center;
`;
